import { inject, Injectable } from "@angular/core";
import { Dashboard, DashboardDoc } from "@fry/dashboards/lib";
import { Api, isOKResponse } from "@fry-it/risr-core";

@Injectable({
    providedIn: 'root'
  })
  export class PortalService {

    api = inject(Api)

    async get(id: string): Promise<Dashboard> {
        const response = await this.api.get<DashboardDoc>('/portals/' + id);
        if (!isOKResponse(response)) {
            throw new Error('Failed to get portal');
        }
        return new Dashboard(response.data);
    }
  }